import { PeopleHappinessFilterAnotherFieldsNames } from '../enums/PeopleHappinessFilterFieldsNames';

export const getPeopleHappinessFiltersLength = (searchParams: URLSearchParams): number => {
  const filters = [...new Set(searchParams.keys())].filter(
    (key) => key !== PeopleHappinessFilterAnotherFieldsNames.GroupBy
  );
  return filters.length;
};
